export default class MozartApi {
    static __refreshPromise = null;
    static __mergeCache = {};

    constructor(keycloak) {
        this.keycloak = keycloak;
    }

    refreshToken = async function () {
        //thread safety: combine concurrent requests into 1 promise
        if (MozartApi.__refreshPromise instanceof Promise) {
            return MozartApi.__refreshPromise;
        } else {
            return MozartApi.__refreshPromise = this.keycloak.updateToken(30)
                .catch(error => {
                    console.error(`Failed to refresh the token, or the session has expired (${error}).  Redirecting to login page.`);
                    // this.keycloak.logout();
                    MozartApi.__refreshPromise = null;
                    return Promise.reject('Failed to refresh the token.')
                })
                .then(refreshed => {
                    if (refreshed) console.debug('token refreshed');
                    MozartApi.__refreshPromise = null;
                    return Promise.resolve();
                });
        }
    }

    fetch = async function (input, init, isblob = false) {
        return this.refreshToken()
            .then(() => {
                if (init === undefined)
                    init = { headers: {} };
                if (init.headers === undefined)
                    init.headers = {};
                init.headers.authorization = `Bearer ${this.keycloak.token}`;

                return fetch(input, init).then(r => this.result(r, isblob));
            });
    }

    get = async function (url) {
        return this.fetch(
            url,
            {
                method: 'get',
                // cache: useBrowserCache === true ? 'default' : 'no-cache'
            }
        );
    }

    post = async function (url, body, contentType, isblob = false, requestOptions = {}) {
        let init = {
            ...requestOptions,
            method: 'post',
            headers: { ...(requestOptions.headers || {}) },
        };
        if (body !== undefined) {
            if (contentType !== null) {
                init.headers['content-type'] = contentType || 'application/json';
            }
            if (init.headers['content-type'] === 'application/json'
                && typeof body !== 'string') {
                body = JSON.stringify(body);
            }
            init['body'] = body;
        }
        return this.fetch(url, init, isblob);
    }

    put = async function (url, body, contentType = 'application/json') {
        let init = { method: 'put', headers: {} };
        if (body !== undefined) {
            if (contentType !== null) {
                init.headers['content-type'] = contentType || 'application/json';
            }
            if (init.headers['content-type'] === 'application/json'
                && typeof body !== 'string') {
                body = JSON.stringify(body);
            }
            init['body'] = body;
        }
        return this.fetch(url, init);
    }

    delete = async function (url) {
        return this.fetch(
            url,
            {
                method: 'delete',
            }
        );
    }

    getblob = async function (url, useBrowserCache = false, merge = true) {
        if (merge === true) {
            if (MozartApi.__mergeCache[url] instanceof Promise) {
                //console.debug('cached promise...');
                return MozartApi.__mergeCache[url];
            } else {
                //console.debug('fetching...');
                return MozartApi.__mergeCache[url] = this.fetch(
                    url,
                    {
                        method: 'get',
                        cache: useBrowserCache === true ? 'default' : 'no-cache'
                    },
                    true
                ).finally(() => {
                    delete MozartApi.__mergeCache[url];
                });
            }
        } else {
            return this.fetch(
                url,
                {
                    method: 'get',
                    cache: useBrowserCache === true ? 'default' : 'no-cache'
                },
                true
            );
        }
    }
    postblob = async function (url, file) {
        if (file === undefined)
            throw new Error('file is required.');
        let formData = new FormData();
        formData.append('file', file);
        let init = { method: 'post', headers: {} };
        init['body'] = formData;
        return this.fetch(url, init);
    }

    result = async function (response, isblob) {
        if (response.ok) { //should be 200 
            if (isblob)
                return response.blob();

            let contentType = (response.headers.get('content-type') ?? '').toLowerCase();
            if (contentType.includes('application/json')) {
                return response.json();
            } else {
                return response.text();
            }
        } else {
            let contentType = (response.headers.get('content-type') ?? '').toLowerCase();
            if (contentType.indexOf('application/problem+json') === 0) {
                return response.json().then(jsonerr => {
                    if (jsonerr.errors && Object.keys(jsonerr.errors).length > 0) {
                        if (jsonerr.errors._action) {
                            return Promise.reject(jsonerr.errors._action);
                        } else {
                            return Promise.reject(jsonerr);
                        }
                    } else if (jsonerr.detail) {
                        return Promise.reject(jsonerr.detail);
                    } else {
                        return Promise.reject(jsonerr.title);
                    }
                });
            } else if (contentType.indexOf('application/json') === 0) {
                return response.json().then(jsonerr => {
                    return Promise.reject(jsonerr.message || jsonerr.Message || jsonerr.error || jsonerr.title);
                });
            } else {
                return response.text().then(txt => {
                    return Promise.reject(`${response.status} ${response.statusText}: ${txt}`);
                });
            }
        }
    }

    htmlEncode = function (str) {
        if (!document.__p) document.__p = document.createElement("p");
        document.__p.textContent = str;
        return document.__p.innerHTML;
    }

}
